/**
 * Read More function allows to show and hide content with a click of a button.
 * There are three important attributes needed for this function to work:
 * - [data-js="read-more"] that activates this function.
 * - [data-js="read-more__content"] that contains the content to show.
 * - [data-js="read-more__button"] that contains the button.
 * Classes with the same names as the attributes are also needed for the proper styling of the component.
 *
 * The content will be shown when the button is clicked and hidden when the button is clicked again.
 * The content will also be shown if the URL has a hash with the id of the content.
 * @module read more function.
 */
export default function readMore() {
	const readMore = document.querySelectorAll('[data-js="read-more"]');
	const hash = window.location.hash;
	if (readMore) {
		for (const item of readMore) {
			const button = item.querySelector('[data-js="read-more__button"]');
			if ('#' + item.id === hash) {
				showCard(item, button);
			}
			if (item.offsetHeight > 230) {
				item.classList.add('c-read-more-js');
				button.addEventListener('click', () => {
					showCard(item, button);
				});
			} else {
				button.style.display = 'none';
			}
		}
	}
}

/**
 * Shows the content of the read-more item and updates the button state.
 *
 * @param {HTMLElement} item - The read-more item containing the content and button.
 * @param {HTMLElement} button - The button that toggles the content visibility.
 */
function showCard(item, button) {
	const itemContent = item.querySelector('[data-js="read-more__content"]');
	itemContent.setAttribute('tabindex', 0);
	itemContent.setAttribute('aria-hidden', 'false');
	button.setAttribute('aria-expanded', 'true');
	item.classList.toggle('c-read-more__expanded');
}
